export default __webpack_public_path__ + "static/media/note-orange.e5a67a78.svg";